@if (globals.i18n !== undefined) {
  <div>
    <router-outlet></router-outlet>
  </div>
}
